import React from 'react'

export const ErrorModal = (props)=>{
        return (
            <div className='opacity-overlay ' style={{ 'display': 'block'}}>
                <div className="container">
                    <div className="popup-wrapper">
                        <div className="col-xs-12 col-sm-5 popup-content">
                            <div>
                                <div className='modal-body'>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h5> You must fill out each field</h5>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <button type="button" className="form-control" onClick={()=>props.ErrorModal()}>OK</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
}



// WEBPACK FOOTER //
// ./src/components/ValuePropositionComponent/Step1/ErrorModal/ErrorModal.jsx